export default "/images/90f6357401f220f0071165308c8e73b2.avif";